
import { Component, Mixins } from "vue-property-decorator";
import { TextAlignKinds } from "../../../../../domain/drawing";
import { default as StyledTextDrawableObjectMixin } from "./StyledTextDrawableObjectMixin.vue";
import { BrowserUtility } from "../../../../../utilities";

@Component
export default class StyledTextPositionDrawableMixin extends Mixins(StyledTextDrawableObjectMixin) {
  $refs!: {
    textPositionMeasure: HTMLTextAreaElement,
  };
  private textPositionHeight: number = null;
  private textPositionCompositionStartText: string = "";
  private textPositionCompositionInputText: string = "";
  private textPositionCompositionEndText: string = "";
  textPositionCompositing: boolean = false;

  get baseTransformFontSize() {
    return 10;
  }

  get transformTextScale() {
    return this.textStyle.displayFontSize / this.baseTransformFontSize;
  }

  get textPositionStyleProperties() {
    return {
      height: this.textPositionHeight !== null ? this.textPositionHeight + "px" : null,
      alignSelf: this.toTextPositionAlignSelf(this.textStyle.textAlign),
    };
  }

  private toTextPositionAlignSelf(kind: TextAlignKinds): string {
    if (kind & TextAlignKinds.Top) {
      return "flex-start";
    } else if (kind & TextAlignKinds.Middle) {
      return "center";
    } else if (kind & TextAlignKinds.Bottom) {
      return "flex-end";
    }
    return null;
  }

  async updateTextPositionHeight() {
    await this.$nextTick();
    const lineHeight = this.textStyle.lineHeight * this.textStyle.displayFontSize;
    const measureHeight = !!this.$refs.textPositionMeasure
      // Chrome以外のscrollHeightはTransformを考慮しない値が返されるため揃える
      ? this.$refs.textPositionMeasure.scrollHeight * (BrowserUtility.isChromiumBrowser() ? 1 : this.transformTextScale)
      : lineHeight;
    this.textPositionHeight = Math.min(Math.max(lineHeight, measureHeight), this.rectangle.height);
  }

  get textPositionMeasureText(): string {
    return this.textPositionCompositionStartText + this.textPositionCompositionInputText + this.textPositionCompositionEndText;
  }

  onTextPositionCompositionStart(e: CompositionEvent) {
    if (!(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement)) {
      return;
    }
    this.textPositionCompositionStartText = e.target.value.slice(0, e.target.selectionStart);
    this.textPositionCompositionInputText = "";
    this.textPositionCompositionEndText = e.target.value.slice(e.target.selectionEnd);
    this.textPositionCompositing = true;
  }

  onTextPositionCompositionUpdate(e: CompositionEvent) {
    this.textPositionCompositionInputText = e.data;
  }

  onTextPositionCompositionEnd(e: CompositionEvent) {
    this.textPositionCompositionStartText = "";
    this.textPositionCompositionInputText = "";
    this.textPositionCompositionEndText = "";
    this.textPositionCompositing = false;
  }
}
